export default "/images/vendor/flag-icons/flags/4x3/im.svg?2bd1c7c77ad07608a2a89bf8222ebc79";